import { InputTableLayoutData } from '../../../../../../baseComponents/TwinTable/InputTableLayout/types';

export const getFilteredTableDataLength = (completeData: InputTableLayoutData) => {
    let filteredLength: null | number = null
    if(completeData.filteredTableData){
        filteredLength = 0
        for (const element of completeData.filteredTableData) {
            let myElement = element
            if (completeData?.dictPosTableData?.[element.id]) {
                myElement = completeData.tableData[completeData?.dictPosTableData?.[myElement?.id]]
            }
            if (myElement?.type !== 'productCombinedHeader' && !myElement?.processsed && myElement?.type !== 'buyHeader' && myElement?.type !== 'deliveryNoteHeader'){
                filteredLength++
            }
        }
    }
    return filteredLength
}